import { useNavigate, useParams } from 'react-router-dom';
import { tasaciones } from '../data/mock';

export default function Resultado() {
  const navigate = useNavigate();
  const { id } = useParams();
  const t = tasaciones.find(tas => tas.id === parseInt(id)) || tasaciones[0];

  if (!t.valor_estimado_usd) {
    return (
      <div className="app-shell">
        <div className="topbar">
          <div className="topbar-left">
            <span className="topbar-back" onClick={() => navigate(-1)}>←</span>
            <div className="topbar-title">Resultado</div>
          </div>
        </div>
        <div className="page-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
          <div style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>📊</div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Sin resultado aún</div>
            <div style={{ fontSize: 12, marginTop: 6 }}>Completá los comparables para calcular</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="topbar-left">
          <span className="topbar-back" onClick={() => navigate(-1)}>←</span>
          <div>
            <div className="topbar-title">Resultado</div>
            <div className="topbar-sub">{t.direccion}</div>
          </div>
        </div>
        <span className="topbar-action">⋮</span>
      </div>

      <div className="page-body">
        <div className="result-hero">
          <div className="result-label">Valor estimado</div>
          <div className="result-value">USD {t.valor_estimado_usd.toLocaleString()}</div>
          <div className="result-range">Rango: USD {t.valor_min_usd.toLocaleString()} – {t.valor_max_usd.toLocaleString()}</div>
          <div className="result-sources">
            <span className="src-chip">Argenprop</span>
            <span className="src-chip">Properati</span>
            <span className="src-chip">CUCICBA</span>
          </div>
        </div>

        <div className="card-flat">
          <div className="result-row">
            <span className="result-row-label">Precio de publicación</span>
            <span className="result-row-val">USD {t.precio_publicacion_usd.toLocaleString()}</span>
          </div>
          <div className="result-row">
            <span className="result-row-label">Precio de realización</span>
            <span className="result-row-val">USD {t.precio_realizacion_usd.toLocaleString()}</span>
          </div>
          <div className="result-row">
            <span className="result-row-label">Margen de negociación</span>
            <span className="result-row-val">~{t.margen_negociacion_pct}%</span>
          </div>
          <div className="result-row">
            <span className="result-row-label">Valor por m²</span>
            <span className="result-row-val" style={{ color: 'var(--teal)' }}>USD {t.valor_m2_usd.toLocaleString()} / m²</span>
          </div>
          {t.cliente && (
            <div className="result-row">
              <span className="result-row-label">Cliente</span>
              <span className="result-row-val">{t.cliente.nombre}</span>
            </div>
          )}
        </div>

        <div className="actions-grid">
          <button className="btn-primary" style={{ borderRadius: 'var(--radius-sm)' }}>
            💾 Guardar
          </button>
          <button className="btn-outline">
            📄 PDF
          </button>
          <button className="btn-outline">
            💬 WhatsApp
          </button>
          <button className="btn-outline">
            ✉️ Email
          </button>
        </div>

        {t.comparables.length > 0 && (
          <>
            <div className="section-header" style={{ marginTop: 20 }}>
              <span className="section-title">Comparables usados</span>
              <span className="section-link" onClick={() => navigate(`/comparables/${t.id}`)}>Ver todos →</span>
            </div>
            {t.comparables.slice(0, 3).map(c => (
              <div key={c.id} className="comp-card">
                <div className="comp-top">
                  <div className="comp-addr">{c.direccion}</div>
                  <div className="comp-price">USD {c.precio_usd.toLocaleString()}</div>
                </div>
                <div className="comp-meta">
                  {c.sup_cubierta} m² · USD {c.precio_m2_usd.toLocaleString()}/m²
                  <span className="source-dot">{c.fuente}</span>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
